import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./EwayBillAuth.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import EwayBill from "../EwayBill";
import { setStatusAuth } from "../../storeSlices/dataSlice";
const EwayBillAuth = () => {
  const dispatch = useDispatch();
  const [ewayBillAuth, setewayBillAuth] = useState([]);
  const [ip, setIp] = useState("");
  const navigate = useNavigate();
  const [details, setdetails] = useState({
    email: "",
    username: "",
    password: "",
    ip_address: "",
    client_id: "",
    client_secret: "",
    gstin: "",
  });
  const handleChange = (e) => {
    setdetails({ ...details, [e.target.name]: e.target.value });
  };
  useEffect(() => {
    getUserIp();
    window.localStorage.setItem("gstin", details.gstin);
  }, [details]);
  const getUserIp = async () => {
    const ip = await axios.get("https://ipapi.co/json");
    setIp(ip.data.ip);
  };
  const getEwayBillAuth = async (details) => {
    // console.log("details ",details);
    const ewaybill = await axios.get(
      //"https://api.mastergst.com/ewaybillapi/v1.03/authenticate?email=sachin.123.kumar.456%40gmail.com&username=05AAACH6188F1ZM&password=abc123%40%40",
      `https://api.mastergst.com/ewaybillapi/v1.03/authenticate?email=sachin.123.kumar.456%40gmail.com&username=${details.username}&password=${details.password}`,
      {
        headers: {
          ip_address: ip,
          //client_id: "a6f557d6-4b96-4c29-8fc6-0e53362c1173",
          //client_secret: "1fce9476-1cf3-451d-9c0b-79622100dc47",
          // gstin: "05AAACH6188F1ZM",
          client_id: "e089a9b4-724d-4958-98d7-4a24f5b96d5c",
          client_secret: "a38ad362-aa30-4e74-bbef-cc075ef6c4e4",
          // gstin: "08GQZPS0985M1ZE",

          // "client_id": details.client_id,
          // "client_secret": details.client_secret,
          gstin: details.gstin,
          "Content-Type": "application/json",
        },
      }
    );
    console.log(ewaybill);
    // console.log("ewaybill ",ewaybill);
    if (ewaybill.data.status_cd === "1") {
      navigate("/dashbaord/chalan/ewaybill");
      dispatch(setStatusAuth(true));
    } else {
      alert("Invalid Credentials");
    }
  };
  // setInterval(() => {
  //   dispatch(setStatusAuth(false));
  // },10000 );
  // setTimeout(() => {
  //   dispatch(setStatusAuth(false));
  // }, 60*60*1000);

  details.ip_address = ip;
  const handleSubmit = async (event) => {
    event.preventDefault();

    // console.log(details);
    const inputfield = document.getElementsByClassName("entry");
    Object.entries(inputfield).forEach((element) => {
      element[1].value = "";
    });
    getEwayBillAuth(details);

    // try {
    //   const response = await fetch(
    //     `https://api.mastergst.com/ewaybillapi/v1.03/authenticate?email=${details.email}&username=${details.username}&password=${details.password}`,
    //     {
    //       method: "POST",
    //       query:{
    //         email: details.email,
    //         username: details.username,
    //         password: details.password,
    //       },

    //       headers: {
    //         "Content-Type": "application/json",
    //         "ip_address": details.ip_address,
    //         "client_id": details.client_id,
    //         "client_secret": details.client_secret,
    //         "gstin": details.gstin,
    //       },
    //       body: JSON.stringify(details),
    //     }
    //   );
    //   const json = await response.json();
    //   console.log(json);
    // } catch (error) {
    //   console.log(error);
    // }

    // document.getElementById("AuthForm").classList.toggle("c-form");
    // document.getElementById("Ewaybill").classList.toggle("bill"); //
  };
  return (
    <div className="auth-div">
      <form id="AuthForm" action="" className="auth" onSubmit={handleSubmit}>
        <input
          type="text"
          required="required"
          className="entry"
          placeholder="UserName"
          name="username"
          value={details.username}
          onChange={handleChange}
        />

        <input
          required="required"
          type="password"
          className="entry"
          placeholder="password"
          name="password"
          value={details.password}
          onChange={handleChange}
        />

        <input
          type="text"
          className="entry"
          placeholder="gstin"
          name="gstin"
          value={details.gstin}
          onChange={handleChange}
        />
        <button>Submit</button>
      </form>
      {/* <EwayBill/> */}
    </div>
  );
};

export default EwayBillAuth;
